export const mergeCustomFields = (custom_fields, availableCustomFields) => {
    custom_fields.forEach((custom_field) => {
        const availableCustomField = availableCustomFields.find((acf) => acf._id === custom_field.custom_field_id);
        if (availableCustomField) {
            availableCustomField.value = custom_field.value;
        }
    });

    return availableCustomFields.map((acf) => ({ ...acf, custom_field_id: acf._id }));
};

const getValue = ({ data_type, value }) => {
    if (data_type === 'date') return value ? new Date(value) : undefined;
    if (data_type === 'number') return value ? parseFloat(value) : undefined;
    return value ?? null;
};

export const formatCustomFields = (customFields) => {
    if (!customFields) return [];
    return customFields.map((field) => ({ custom_field_id: field.custom_field_id, value: getValue(field) }));
};

export const dataTypesMap = {
    string: 'Text',
    number: 'Number',
    date: 'Date',
    boolean: 'Checkbox',
    select: 'Select',
    multi_line: 'Multi-Line',
};

export const producerCategoriesMap = {
    information: 'Information',
    account_details: 'Account Details',
    physical_location: 'Physical Location',
    pay_information: 'Pay Information',
    tank_management: 'Tank Management',
    pickups_and_haulings: 'Pickups and Haulings',
};
